import React from "react";
import OTPInput from "react-otp-input";

type PropsType = {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  error: boolean;
  isFilled: boolean;
  shouldAutoFocus: boolean;
};

const OtpInput: React.FC<PropsType> = ({
  value,
  onChange,
  disabled,
  error,
  isFilled,
  shouldAutoFocus,
}) => {
  return (
    <OTPInput
      skipDefaultStyles
      numInputs={4}
      onChange={onChange}
      value={value}
      inputType={"tel"}
      renderInput={(props) => (
        <input
          {...props}
          disabled={disabled}
          className={error ? "red" : isFilled ? "green" : ""}
        />
      )}
      shouldAutoFocus={shouldAutoFocus}
    />
  );
};

export default OtpInput;
